'use strict';
var parent = require('../../es/promise/with-resolvers');

module.exports = parent;
